import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import About from "./About";
import { useEffect } from "react";

const SLIDES = [
  {
    image:
      "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/about/banner.png",
    title: "Ordinary was never an option.",
    subtitle: "Born from three little moods. Built for every child's",
  },
];
const FALLBACK_IMAGE =
  "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/product-placeholder.svg";

const AboutV2 = () => {
  useEffect(() => {
    document.title = "About | HueHoppers – Joyful Kids' Fashion";
  }, []);
  return (
    <>
      <div className="tf-slideshow slider-home-2 slider-effect-fade position-relative">
        <Swiper
          modules={[Autoplay, Pagination, EffectFade]}
          effect="fade"
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          speed={1000}
          pagination={{
            clickable: true,
            el: ".sw-pagination-slider",
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
          }}
          slidesPerView={1}
          className="tf-sw-slideshow"
        >
          {SLIDES.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="wrap-slider">
                <img
                  loading="lazy"
                  decoding="async"
                  src={slide.image}
                  onError={(event) => {
                    event.currentTarget.onerror = null;
                    event.currentTarget.src = FALLBACK_IMAGE;
                  }}
                  alt={`banner-${index + 1}`}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                    zIndex: 0,
                    border: "2px solid white",
                  }}
                />
                <div className="box-content">
                  <div className="container">
                    <h1 className="fade-item fade-item-1  text_white">
                      {slide.title.split(" for ").map((part, i) => (
                        <span key={i}>{part}</span>
                      ))}
                    </h1>
                    <p
                      className="fade-item fade-item-2 text_white"
                      dangerouslySetInnerHTML={{ __html: slide.subtitle }}
                      style={{ display: "block" }}
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Pagination dots */}
        <div className="wrap-pagination sw-absolute-2">
          <div className="container">
            <div className="sw-dots dots-fill-white justify-content-center sw-pagination-slider swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal" />
          </div>
        </div>
      </div>
      <section className="flat-spacing-16">
        <div className="container">
          <div className="tf-grid-layout md-col-2">
            <div className="tf-ourstore-img">
              <img
                loading="lazy"
                decoding="async"
                className=" ls-is-cached lazyloaded"
                data-src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/about/section1.png"
                src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/about/section1.png"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = FALLBACK_IMAGE;
                }}
                alt="our-store"
              />
            </div>
            <div className="tf-ourstore-content">
              <h3 className="mb_24 ">Where Craft Meets Conviction</h3>
              <div className="mb_20">
                <p style={{ fontSize: 22, lineHeight: 1.5 }}>
                  At HueHoppers, we are governed by a singular, uncompromising
                  conviction that excellence is not a destination, but a
                  discipline. Every character we breathe life into, every
                  pigment we curate, every thread we commission is the result of
                  relentless deliberation.
                  <br />
                  <br />
                  We do not create clothing. We architect emotional experiences
                  garments that speak the language a child feels but cannot yet
                  articulate.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="flat-spacing-10">
        <div className="container">
          <div className="tf-grid-layout md-col-2">
            <div className="tf-ourstore-content">
              <h3 className="mb_24 ">How it all began</h3>
              <div className="mb_20">
                <p style={{ fontSize: 22, lineHeight: 1.5 }}>
                  We are a couple raising three children three distinct
                  personalities, three entirely different moods before
                  breakfast. <br />
                  One quiet evening changed everything. <br />
                  Our eldest, Navu, pointed at a sleepy little dinosaur and said
                  <span style={{ fontStyle: "italic" }}>
                    "Yeh toh Ridu hai"
                  </span>{" "}
                  Ridu, our youngest a child who could sleep through anything,
                  anywhere, with extraordinary commitment. <br />
                  Then Kayu, our middle one, spotted the vacation illustration
                  and announced{" "}
                  <span style={{ fontStyle: "italic" }}>
                    "Yeh mujhe abhi chahiye"
                  </span>
                  .
                  <br />
                  Three children. Three instinctive reactions. Three moods
                  recognised in three designs.
                </p>
              </div>
            </div>
            <div className="tf-ourstore-img">
              <img
                loading="lazy"
                decoding="async"
                className=" ls-is-cached lazyloaded"
                data-src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/about/section2.png"
                src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/about/section2.png"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = FALLBACK_IMAGE;
                }}
                alt="our-store"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="flat-spacing-10">
        <div className="container">
          <div className="tf-grid-layout md-col-2">
            <div className="tf-ourstore-img">
              <img
                loading="lazy"
                decoding="async"
                className=" ls-is-cached lazyloaded"
                data-src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/about/section3.png"
                src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/about/section3.png"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = FALLBACK_IMAGE;
                }}
                alt="our-store"
              />
            </div>
            <div className="tf-ourstore-content">
              <h3 className="mb_24 ">The Realisation</h3>
              <div className="mb_20">
                <p style={{ fontSize: 22, lineHeight: 1.5 }}>
                  Kids don't just wear clothes. They wear their feelings. <br />
                  <br /> If our three little ones could instantly see themselves
                  in a design why couldn't every child? <br />
                  <br /> That's how HueHoppers was born.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="flat-spacing-10">
        <div className="container">
          <div className="tf-grid-layout md-col-2">
            <div className="tf-ourstore-content">
              <h3 className="mb_24 ">The Promise</h3>
              <div className="mb_20">
                <p style={{ fontSize: 22, lineHeight: 1.5 }}>
                  Your child is never just one mood. They are Sleepy Ridu on a
                  slow Monday morning. Unstoppable Kayu chasing the afternoon
                  sun. And the undisputed ruler of their universe on every
                  birthday. <br />
                  <br /> At HueHoppers, we don't make clothing. <br />
                  <br /> <b>We craft moods worth wearing.</b>
                  <br />
                  <br /> Hop into your hue. Every single day.
                </p>
              </div>
            </div>
            <div className="tf-ourstore-img">
              <img
                loading="lazy"
                decoding="async"
                className=" ls-is-cached lazyloaded"
                data-src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/about/section4.png"
                src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/about/section4.png"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = FALLBACK_IMAGE;
                }}
                alt="our-store"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutV2;
